/* eslint-disable */
import * as types from "../types/userTypes";
import { headers, routes } from "../../api/user-api";
import * as axios from "axios";
import { isEmpty, reject } from "lodash";
import { LOCAL_STORAGE } from "../../utils/constant";

export const createUser = (user) => {
  return {
    type: types.AUTH_CREATE_USER,
    user,
  };
};

export const signInUser = (user) => {
  return {
    type: types.AUTH_SIGNIN_USER,
    user,
  };
};

export function signInFetchData(username, password, module_name) {
  return (dispatch) => {
    return axios
      .post(`${process.env.REACT_APP_LOGIN_ENDPOINT}`, { username, password, module_name })
      .then((res) => {
        if (!isEmpty(res.data.resultSet)) {
          dispatch(signInUser(res.data.resultSet));
          return new Promise(function (resolve) {
            resolve(res.data.resultSet);
          });
        }
      })
      .catch((err) => {
        return err;
      });
  };
}

export function autoLogin(token, userKey) {
  return (dispatch) => {
    return axios
      .post(`${process.env.REACT_APP_AUTO_LOGIN}`, { token, userKey })
      .then((res) => {
        if (!isEmpty(res.data.resultSet)) {
          dispatch(signInUser(res.data.resultSet));
          return new Promise(function (resolve) {
            resolve(res.data.resultSet);
          });
        }
      })
      .catch((err) => {
        return err;
      });
  };
}

export const authLogoutUser = () => {
  return {
    type: types.AUTH_LOGOUT_USER,
  };
};

export function logout() {
  return (dispatch) => {

    if (LOCAL_STORAGE.customerNo == "1158") {
      window.location.href = "https://snowlink.snowman.in/"
    }
    else if (LOCAL_STORAGE.customerNo == 1568) {
      window.location.href = "https://patang.elixia.tech/"
    }
    localStorage.clear();
    dispatch(authLogoutUser());
  };
}
